export const UnsupportedScreen = () => (
  <main className="screen">
    <h1>Provisium Mini App</h1>
    <p className="lead">
      Откройте это приложение из Telegram-бота <strong>@provisium_market_bot</strong> или из MAX.
    </p>
    <p className="muted">
      Для локальной разработки задайте <code>VITE_DEV_MOCK_AUTH=true</code> в <code>.env</code>.
    </p>
  </main>
)
